import { Card, Grid, Paper, Typography, CardContent, Stack, TextField, ButtonGroup, Button, CardHeader } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Loading from '../../components/Loading';
import { useCreateSalesRepMutation, useListSalesRepsQuery } from '../../features/model/salesrepSlice';

const AddNewCard = ({onAddNew = null}) => {
  return (
      <Paper elevation={1}><Card key="add_new" sx={{width: 256, minHeight: 140, paddingTop: 2}}>
          <center><Typography variant="subtitle1">Add new</Typography></center>
          <center><TextField
              sx={{marginTop: 2}}
              placeholder='Type and press enter...'
              onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onAddNew(e.target.value);
                  }
              }}
          /></center>
      </Card></Paper>);
}

const ObjectCard = ({object}) => {
  const makeLinkToObject = (object) => {
    return `/salesreps/${object.id}`
  }

  return <Grid item component={RouterLink} to={makeLinkToObject(object)}>
    <Paper elevation={1}>
      <Card sx={{width: 256}}>
        <CardHeader title={object.name} subheader={object.status} />
      </Card>
    </Paper>
  </Grid>
}

const SalesRepsBrowser = () => {
    const [filters, setFilters] = useState({status: "active"})
    const {data, error, isLoading } = useListSalesRepsQuery(filters);
    const [createRep, {isLoadingUpdate: isUpdating }] = useCreateSalesRepMutation();

    function createNew(name) {
        createRep({name: name});
    }

    if (isLoading || isUpdating) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const sortedObjects = data.objects.slice().sort((a, b) => a.name.localeCompare(b.name))

    return <Stack direction="column">
        <ButtonGroup sx={{marginTop: 2}}>
          <Button variant={filters.status === "active" ? "contained" : "outlined"} onClick={(e) => {setFilters({status: "active"})}}>Active only</Button>
          <Button variant={Object.keys(filters).length === 0 ? "contained" : "outlined"} onClick={(e) => {setFilters({})}}>All</Button>
          <Button variant={filters.status === "inactive" ? "contained" : "outlined"} onClick={(e) => {setFilters({status: "inactive"})}}>Inactive only</Button>
        </ButtonGroup>
        <Grid container spacing={2} sx={{marginTop: 2, marginBottom: 4}}>
          {
              sortedObjects.map((object, i) => <ObjectCard object={object} key={object.id} />)
          }
        </Grid>
        <Grid container spacing={2} sx={{marginTop: 2, marginBottom: 4}}>
          <Grid item key="new"><AddNewCard onAddNew={createNew}/></Grid>
        </Grid>
      </Stack>
}

export default SalesRepsBrowser;
